
import styles from '../ProductInfo.module.css';

interface InitialsInputProps {
    initial1: string;
    setInitial1: (val: string) => void;
    initial2: string;
    setInitial2: (val: string) => void;
    separator: string;
    setSeparator: (val: string) => void;
}

export const InitialsInput = ({
    initial1,
    setInitial1,
    initial2,
    setInitial2,
    separator,
    setSeparator
}: InitialsInputProps) => {
    return (
        <>
            <h4 className={styles.customizationTitle}>Définissez vos initiales</h4>
            <div className={styles.initialsWrapper}>
                <input
                    maxLength={1}
                    type="text"
                    className={styles.initialInput}
                    placeholder="M"
                    value={initial1}
                    onChange={(e) => setInitial1(e.target.value.toUpperCase())}
                />
                <div className={styles.separatorSelectWrapper}>
                    <select
                        className={styles.separatorSelect}
                        value={separator}
                        onChange={(e) => setSeparator(e.target.value)}
                    >
                        <option value="et">et</option>
                        <option value="&">&</option>
                        <option value="coeur">♡</option>
                        <option value="vide">Vide</option>
                    </select>
                </div>
                <input
                    maxLength={1}
                    type="text"
                    className={styles.initialInput}
                    placeholder="C"
                    value={initial2}
                    onChange={(e) => setInitial2(e.target.value.toUpperCase())}
                />
            </div>
        </>
    );
};
